import React, { ReactNode, FC } from 'react'
import { Box, makeStyles } from 'transfix-ui/core'
import { AppNavBar } from '../AppNavBar'

const useAppFrameStyles = makeStyles({
  root: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  appNavBarContainer: {
    flex: '0 0 auto',

    // This is just to raise it above images, etc.
    zIndex: 1,
  },
  contentContainer: {
    position: 'relative',
    flex: '1 1 auto',
  },
})

export interface IAppFrameProps {
  children: ReactNode
  /**
   * Set by the `mobileApp` query param. Toggles the header for the mobile app webviews.
   * @default false
   */
  isMobileApp?: boolean
}

/**
 * Used to display top <AppNavBar /> and Onboarding content
 */
export const AppFrame: FC<IAppFrameProps> = ({ children, isMobileApp = false }) => {
  const classes = useAppFrameStyles()
  return (
    <Box className={classes.root}>
      {!isMobileApp && (
        <Box className={classes.appNavBarContainer}>
          <AppNavBar />
        </Box>
      )}
      <Box className={classes.contentContainer}>{children}</Box>
    </Box>
  )
}

export default AppFrame
